<template>
    <Checkbox
        class="mr-2"
        :value="item.uid"
        :label="item.name || item.label"
        name="assigned-groups"
        :modelValue="checked"
        :is-disabled="disabled"
        @update:modelValue="handleOnUpdate"
    />
    <img v-if="item.img" :src="item.img" class="w-6 h-6 mr-1" alt=""/>
</template>

<script setup>
import Checkbox from "@/components/core/Checkbox.vue";

const emit = defineEmits(['checked', 'unchecked']);

const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    checked: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const handleOnUpdate = (value) => {
    if (value) {
        emit('checked', props.item.uid);
    } else {
        emit('unchecked', props.item.uid);
    }
}

</script>
